import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Card, Row, Col, Badge, Spinner, Alert, Button, Table, ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { fetchAnalyticsRealtime, fetchAnalyticsStatus } from '../../services/api';

// Coordenadas das principais cidades brasileiras
const cityCoordinates = {
    'São Paulo': { lat: -23.55, lng: -46.63 },
    'Rio de Janeiro': { lat: -22.91, lng: -43.17 },
    'Belo Horizonte': { lat: -19.92, lng: -43.94 },
    'Brasília': { lat: -15.79, lng: -47.88 },
    'Salvador': { lat: -12.97, lng: -38.50 },
    'Fortaleza': { lat: -3.72, lng: -38.54 },
    'Curitiba': { lat: -25.43, lng: -49.27 },
    'Recife': { lat: -8.05, lng: -34.88 },
    'Porto Alegre': { lat: -30.03, lng: -51.23 },
    'Manaus': { lat: -3.12, lng: -60.02 },
    'Goiânia': { lat: -16.68, lng: -49.25 },
    'Campinas': { lat: -22.91, lng: -47.06 },
    'Limeira': { lat: -22.56, lng: -47.40 },
    'Piracicaba': { lat: -22.73, lng: -47.65 },
    'Ribeirão Preto': { lat: -21.18, lng: -47.81 },
    'Santos': { lat: -23.96, lng: -46.33 },
    'Niterói': { lat: -22.88, lng: -43.10 },
    'Natal': { lat: -5.79, lng: -35.21 },
    'João Pessoa': { lat: -7.12, lng: -34.86 },
    'Campo Grande': { lat: -20.47, lng: -54.62 },
    'Cuiabá': { lat: -15.60, lng: -56.10 },
    'Florianópolis': { lat: -27.59, lng: -48.55 },
    'Vitória': { lat: -20.32, lng: -40.34 },
    'Belém': { lat: -1.46, lng: -48.50 },
    'São Luís': { lat: -2.53, lng: -44.27 },
    'Maceió': { lat: -9.67, lng: -35.74 },
    'Teresina': { lat: -5.09, lng: -42.80 },
    'Aracaju': { lat: -10.91, lng: -37.07 },
    'Londrina': { lat: -23.30, lng: -51.18 },
    'Joinville': { lat: -26.30, lng: -48.84 },
    'Americana': { lat: -22.74, lng: -47.33 },
    'Sorocaba': { lat: -23.50, lng: -47.46 },
    'Jundiaí': { lat: -23.19, lng: -46.88 },
    'São Carlos': { lat: -22.01, lng: -47.89 },
    'Bauru': { lat: -22.33, lng: -49.07 },
    'São José dos Campos': { lat: -23.18, lng: -45.88 },
    'Uberlândia': { lat: -18.92, lng: -48.28 },
    'Contagem': { lat: -19.93, lng: -44.05 },
    'Osasco': { lat: -23.53, lng: -46.79 },
    'Guarulhos': { lat: -23.46, lng: -46.53 },
    'Santo André': { lat: -23.66, lng: -46.54 },
    'São Bernardo do Campo': { lat: -23.69, lng: -46.56 },
    'Duque de Caxias': { lat: -22.79, lng: -43.31 },
    'Nova Iguaçu': { lat: -22.76, lng: -43.45 },
    'São Gonçalo': { lat: -22.83, lng: -43.07 },
    'Jaboatão dos Guararapes': { lat: -8.11, lng: -35.02 },
    'Olinda': { lat: -8.01, lng: -34.85 },
    'Feira de Santana': { lat: -12.27, lng: -38.97 },
    'Aparecida de Goiânia': { lat: -16.82, lng: -49.24 },
    'Anápolis': { lat: -16.33, lng: -48.95 },
    'Juiz de Fora': { lat: -21.76, lng: -43.35 },
    'Montes Claros': { lat: -16.73, lng: -43.86 },
    'Pelotas': { lat: -31.77, lng: -52.34 },
    'Caxias do Sul': { lat: -29.17, lng: -51.18 },
    'Canoas': { lat: -29.92, lng: -51.18 },
    'Maringá': { lat: -23.43, lng: -51.94 },
    'Ponta Grossa': { lat: -25.09, lng: -50.16 },
    'Blumenau': { lat: -26.92, lng: -49.07 },
    'Itajaí': { lat: -26.91, lng: -48.67 },
    'Anapolis': { lat: -16.33, lng: -48.95 },
    'Aracatuba': { lat: -21.21, lng: -50.43 },
    'Barueri': { lat: -23.51, lng: -46.88 },
    'Simoes Filho': { lat: -12.78, lng: -38.40 },
    'Barra do Pirai': { lat: -22.47, lng: -43.83 },
    'Praia Grande': { lat: -24.01, lng: -46.41 },
    'Sao Paulo': { lat: -23.55, lng: -46.63 },
    'Uberlandia': { lat: -18.92, lng: -48.28 }
};

// Tradução de eventos GA4 para português
const eventTranslations = {
    'page_view': 'Visualização de Página',
    'session_start': 'Início de Sessão',
    'first_visit': 'Primeira Visita',
    'user_engagement': 'Engajamento do Usuário',
    'scroll': 'Rolagem de Página',
    'click': 'Clique',
    'view_item': 'Visualizou Produto',
    'view_item_list': 'Visualizou Lista de Produtos',
    'select_item': 'Selecionou Produto',
    'add_to_cart': 'Adicionou ao Carrinho',
    'remove_from_cart': 'Removeu do Carrinho',
    'begin_checkout': 'Iniciou Checkout',
    'add_payment_info': 'Adicionou Info de Pagamento',
    'add_shipping_info': 'Adicionou Info de Envio',
    'purchase': 'Compra Realizada',
    'refund': 'Reembolso',
    'view_promotion': 'Visualizou Promoção',
    'select_promotion': 'Selecionou Promoção',
    'search': 'Pesquisa',
    'view_search_results': 'Visualizou Resultados',
    'login': 'Login',
    'sign_up': 'Cadastro',
    'share': 'Compartilhamento',
    'file_download': 'Download de Arquivo'
};

// Ícones para eventos
const eventIcons = {
    'page_view': '👁️',
    'session_start': '🚀',
    'first_visit': '👋',
    'user_engagement': '💡',
    'scroll': '📜',
    'click': '👆',
    'view_item': '👀',
    'view_item_list': '📋',
    'select_item': '✅',
    'add_to_cart': '🛒',
    'remove_from_cart': '❌',
    'begin_checkout': '🛍️',
    'add_payment_info': '💳',
    'add_shipping_info': '📦',
    'purchase': '💰',
    'refund': '↩️',
    'view_promotion': '🏷️',
    'select_promotion': '🎯',
    'search': '🔍',
    'view_search_results': '📄',
    'login': '🔐',
    'sign_up': '📝',
    'share': '📤',
    'file_download': '⬇️'
};

// Cores para eventos
const eventColors = {
    'purchase': 'success',
    'add_to_cart': 'warning',
    'begin_checkout': 'info',
    'view_item': 'primary',
    'page_view': 'secondary',
    'session_start': 'dark',
    'first_visit': 'info'
};

// Descrições dos eventos para tooltip (breves)
const eventDescriptions = {
    'page_view': 'Página visualizada',
    'session_start': 'Sessão iniciada',
    'first_visit': 'Primeiro acesso',
    'user_engagement': 'Usuário engajado',
    'scroll': 'Rolagem 90%',
    'click': 'Clique',
    'view_item': 'Viu produto',
    'view_item_list': 'Viu lista',
    'select_item': 'Selecionou item',
    'add_to_cart': 'Adicionou ao carrinho',
    'remove_from_cart': 'Removeu do carrinho',
    'begin_checkout': 'Iniciou compra',
    'add_payment_info': 'Info pagamento',
    'add_shipping_info': 'Info entrega',
    'purchase': 'Compra realizada!',
    'refund': 'Reembolso',
    'view_promotion': 'Viu promoção',
    'select_promotion': 'Clicou promoção',
    'search': 'Pesquisou',
    'view_search_results': 'Viu resultados',
    'login': 'Fez login',
    'sign_up': 'Se cadastrou',
    'share': 'Compartilhou',
    'file_download': 'Baixou arquivo',
    'form_start': 'Iniciou formulário',
    'form_submit': 'Enviou formulário'
};

// Função para obter descrição do evento
const getEventDescription = (eventName) => {
    return eventDescriptions[eventName] || 'Evento registrado pelo Google Analytics';
};

// Função para verificar se cidade é válida
const isValidCity = (city) => {
    if (!city) return false;
    const invalid = ['(not set)', '(other)', '', ' ', 'not set', 'other', '(not provided)'];
    return !invalid.includes(city.toLowerCase().trim());
};

// Função para traduzir evento
const translateEvent = (eventName) => {
    return eventTranslations[eventName] || eventName;
};

// Função para obter ícone do evento
const getEventIcon = (eventName) => {
    return eventIcons[eventName] || '📌';
};

// Função para obter cor do evento
const getEventColor = (eventName) => {
    return eventColors[eventName] || 'secondary';
};

const MapaDeCalor = () => {
    const [status, setStatus] = useState(null);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isPaused, setIsPaused] = useState(false);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [mapReady, setMapReady] = useState(false);
    const intervalRef = useRef(null);
    const mapRef = useRef(null);
    const mapContainerRef = useRef(null);
    const markersRef = useRef([]);

    const loadData = useCallback(async () => {
        try {
            setError(null);
            const result = await fetchAnalyticsRealtime();
            if (result.success) {
                setData(result.data);
                setLastUpdate(new Date());
            } else {
                setError(result.error || 'Erro ao buscar dados');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    const checkStatus = useCallback(async () => {
        try {
            const statusResult = await fetchAnalyticsStatus();
            setStatus(statusResult);
            return statusResult.initialized;
        } catch (err) {
            return false;
        }
    }, []);

    useEffect(() => {
        const init = async () => {
            const isReady = await checkStatus();
            if (isReady) {
                await loadData();
            }
            setLoading(false);
        };
        init();
    }, [checkStatus, loadData]);

    // Inicializar mapa após loading terminar
    useEffect(() => {
        if (loading) return;

        // Pequeno delay para garantir que o DOM está pronto
        const timer = setTimeout(() => {
            if (mapContainerRef.current && !mapRef.current) {
                try {
                    mapRef.current = L.map(mapContainerRef.current, {
                        center: [-15.79, -47.88],
                        zoom: 4,
                        zoomControl: true,
                        scrollWheelZoom: true
                    });

                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '© OpenStreetMap',
                        maxZoom: 18
                    }).addTo(mapRef.current);

                    setMapReady(true);

                    // Forçar redimensionamento
                    setTimeout(() => {
                        if (mapRef.current) {
                            mapRef.current.invalidateSize();
                        }
                    }, 100);
                } catch (err) {
                    console.error('Erro ao inicializar mapa:', err);
                }
            }
        }, 200);

        return () => {
            clearTimeout(timer);
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, [loading]);

    // Atualizar marcadores quando dados mudam
    useEffect(() => {
        if (!mapRef.current || !mapReady || !data?.locations) return;

        // Limpar marcadores anteriores
        markersRef.current.forEach(marker => {
            try {
                marker.remove();
            } catch (e) { }
        });
        markersRef.current = [];

        // Adicionar novos marcadores
        const validLocations = [];
        data.locations.forEach(loc => {
            const coords = cityCoordinates[loc.city];
            if (coords) {
                const radius = Math.min(25, Math.max(8, loc.users * 4));
                const circle = L.circleMarker([coords.lat, coords.lng], {
                    radius: radius,
                    fillColor: '#007bff',
                    fillOpacity: 0.7,
                    color: '#0056b3',
                    weight: 2
                }).addTo(mapRef.current);

                circle.bindPopup(`
                    <div style="text-align: center; min-width: 120px;">
                        <strong style="font-size: 14px;">${loc.city}</strong>
                        <br/>
                        <span style="color: #666; font-size: 12px;">${loc.country}</span>
                        <hr style="margin: 8px 0; border-color: #eee;" />
                        <span style="background: #007bff; color: white; padding: 4px 12px; border-radius: 4px; font-size: 13px;">
                            ${loc.users} usuário${loc.users > 1 ? 's' : ''} ativo${loc.users > 1 ? 's' : ''}
                        </span>
                    </div>
                `);

                markersRef.current.push(circle);
                validLocations.push([coords.lat, coords.lng]);
            }
        });

        // Ajustar zoom para mostrar todos os pontos
        if (validLocations.length > 0 && mapRef.current) {
            try {
                if (validLocations.length === 1) {
                    mapRef.current.setView(validLocations[0], 10);
                } else {
                    const bounds = L.latLngBounds(validLocations);
                    mapRef.current.fitBounds(bounds, { padding: [50, 50], maxZoom: 8 });
                }
            } catch (e) {
                console.error('Erro ao ajustar bounds:', e);
            }
        }
    }, [data?.locations, mapReady]);

    // Auto-refresh a cada 30 segundos
    useEffect(() => {
        if (!isPaused && status?.initialized) {
            intervalRef.current = setInterval(loadData, 30000);
        }
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isPaused, status, loadData]);

    const togglePause = () => {
        setIsPaused(!isPaused);
    };

    // Status não inicializado
    if (!loading && status && !status.initialized) {
        return (
            <div className="p-4">
                <Alert variant="warning">
                    <Alert.Heading>⚙️ Google Analytics não configurado</Alert.Heading>
                    <p>Configure o GA4 para visualizar o mapa de calor em tempo real.</p>
                </Alert>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Carregando dados em tempo real...</p>
            </div>
        );
    }

    return (
        <div className="p-3">
            {/* Header */}
            <Row className="align-items-center mb-4">
                <Col md={6}>
                    <h4 className="mb-0">
                        🗺️ Mapa de Calor - Tempo Real
                    </h4>
                    <small className="text-muted">
                        Usuários ativos na loja agora
                    </small>
                </Col>
                <Col md={6} className="text-end">
                    <Badge bg={isPaused ? 'warning' : 'success'} className="me-2 py-2 px-3">
                        {isPaused ? '⏸️ Pausado' : '🟢 Ao Vivo'}
                    </Badge>
                    <Button
                        variant={isPaused ? 'success' : 'outline-warning'}
                        size="sm"
                        onClick={togglePause}
                        className="me-2"
                    >
                        {isPaused ? '▶️ Retomar' : '⏸️ Pausar'}
                    </Button>
                    <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={loadData}
                        disabled={loading}
                    >
                        🔄 Atualizar
                    </Button>
                    {lastUpdate && (
                        <div className="mt-1">
                            <small className="text-muted">
                                Última atualização: {lastUpdate.toLocaleTimeString('pt-BR')}
                            </small>
                        </div>
                    )}
                </Col>
            </Row>

            {error && (
                <Alert variant="danger" className="mb-3">{error}</Alert>
            )}

            {/* Cards de resumo */}
            <Row className="g-3 mb-4">
                <Col md={3}>
                    <Card className="border-0 shadow-sm text-center h-100 bg-primary text-white">
                        <Card.Body>
                            <h6 className="mb-2 opacity-75">Usuários Ativos</h6>
                            <h2 className="fw-bold mb-0">
                                {data?.activeUsers || 0}
                            </h2>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className="border-0 shadow-sm text-center h-100">
                        <Card.Body>
                            <h6 className="text-muted mb-2">📱 Mobile</h6>
                            <h3 className="fw-bold text-info mb-0">
                                {data?.devices?.mobile || 0}
                            </h3>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className="border-0 shadow-sm text-center h-100">
                        <Card.Body>
                            <h6 className="text-muted mb-2">💻 Desktop</h6>
                            <h3 className="fw-bold text-success mb-0">
                                {data?.devices?.desktop || 0}
                            </h3>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card className="border-0 shadow-sm text-center h-100">
                        <Card.Body>
                            <h6 className="text-muted mb-2">📍 Cidades</h6>
                            <h3 className="fw-bold text-warning mb-0">
                                {data?.locations?.filter(loc => isValidCity(loc.city)).length || 0}
                            </h3>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="g-4">
                {/* Mapa Leaflet */}
                <Col md={7}>
                    <Card className="border-0 shadow-sm h-100">
                        <Card.Header className="bg-white py-3 d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">📍 Localização dos Usuários</h6>
                            <small className="text-muted">Use scroll para zoom • Arraste para mover</small>
                        </Card.Header>
                        <Card.Body className="p-0" style={{ position: 'relative' }}>
                            <div
                                ref={mapContainerRef}
                                id="leaflet-map-container"
                                style={{
                                    height: '500px',
                                    width: '100%',
                                    borderRadius: '0 0 8px 8px',
                                    background: '#e8e8e8'
                                }}
                            />
                            {!mapReady && (
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'rgba(255,255,255,0.8)'
                                }}>
                                    <Spinner animation="border" variant="primary" />
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                {/* Lista de cidades */}
                <Col md={5}>
                    <Card className="border-0 shadow-sm h-100">
                        <Card.Header className="bg-white py-3">
                            <h6 className="mb-0">🏙️ Top Cidades</h6>
                        </Card.Header>
                        <Card.Body className="p-0" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            {data?.locations?.filter(loc => isValidCity(loc.city)).length > 0 ? (
                                <Table hover className="mb-0">
                                    <thead className="bg-light sticky-top">
                                        <tr>
                                            <th className="ps-3">Cidade</th>
                                            <th className="text-center" style={{ width: '80px' }}>Usuários</th>
                                            <th style={{ width: '35%' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.locations.filter(loc => isValidCity(loc.city)).slice(0, 15).map((loc, idx) => (
                                            <tr key={idx}>
                                                <td className="ps-3">
                                                    <strong>{loc.city}</strong>
                                                    <br />
                                                    <small className="text-muted">{loc.country}</small>
                                                </td>
                                                <td className="text-center">
                                                    <Badge bg="primary" className="fs-6">{loc.users}</Badge>
                                                </td>
                                                <td>
                                                    <ProgressBar
                                                        now={(loc.users / (data.activeUsers || 1)) * 100}
                                                        variant="info"
                                                        style={{ height: '8px' }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <div className="text-center py-5 text-muted">
                                    <div className="fs-1 mb-2">📍</div>
                                    Nenhum usuário ativo no momento
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Páginas e Eventos */}
            <Row className="g-4 mt-2">
                {/* Páginas populares */}
                <Col md={6}>
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-white py-3">
                            <h6 className="mb-0">📄 Páginas Mais Acessadas</h6>
                        </Card.Header>
                        <Card.Body className="p-0">
                            {data?.pages?.length > 0 ? (
                                <Table hover className="mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="ps-3">Página</th>
                                            <th className="text-center">Ativos</th>
                                            <th className="text-center">Views</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.pages.slice(0, 8).map((page, idx) => (
                                            <tr key={idx}>
                                                <td className="ps-3">
                                                    <small className="text-truncate d-block" style={{ maxWidth: '280px' }}>
                                                        {page.page}
                                                    </small>
                                                </td>
                                                <td className="text-center">
                                                    <Badge bg="success">{page.activeUsers}</Badge>
                                                </td>
                                                <td className="text-center">
                                                    <Badge bg="secondary">{page.views}</Badge>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <div className="text-center py-4 text-muted">
                                    Nenhuma página sendo acessada
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                {/* Eventos recentes */}
                <Col md={6}>
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-white py-3">
                            <h6 className="mb-0">⚡ Eventos Recentes</h6>
                        </Card.Header>
                        <Card.Body className="p-0">
                            {data?.events?.length > 0 ? (
                                <Table hover className="mb-0">
                                    <thead className="bg-light">
                                        <tr>
                                            <th className="ps-3">Evento</th>
                                            <th className="text-center">Contagem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.events.slice(0, 8).map((event, idx) => (
                                            <tr
                                                key={idx}
                                                style={{ cursor: 'help' }}
                                                title={getEventDescription(event.name)}
                                            >
                                                <td className="ps-3">
                                                    <Badge bg={getEventColor(event.name)} className="me-2">
                                                        {getEventIcon(event.name)}
                                                    </Badge>
                                                    {translateEvent(event.name)}
                                                </td>
                                                <td className="text-center">
                                                    <strong>{event.count}</strong>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <div className="text-center py-4 text-muted">
                                    Nenhum evento registrado
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default MapaDeCalor;
